exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#proveedores[data-v-1c7513b8] {\n  border: 0;\n  position: relative;\n  border-radius: 4px;\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n}\n#proveedores > .panel-heading[data-v-1c7513b8] {\n  color: #333;\n  border: 0;\n  padding: 10px 27px 10px 10px;\n  position: relative;\n  font-size: 14px;\n  font-style: normal;\n  background: #ccd1d9;\n  font-weight: 600;\n  text-align: center;\n}\n#proveedores > .table > tbody[data-v-1c7513b8] {\n  font-family: monospace;\n}", ""]);

// exports
